var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-col gap-y-md"},[_vm._l((_vm.packageCount),function(i){return (true)?_c('dd-skeleton-header-card',{key:i,attrs:{"action-count":3}}):_vm._e()}),_vm._v(" "),(true)?_c('dd-skeleton-header-card'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }